import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Global from 'models/Global';
import Track from 'models/Track';
import AgendaTrackView from 'views/AgendaTrackView';
import backboneCollectionView from 'backbone-collectionView';
import Config from 'config';
import template from 'hbars!templates/agendaSidebar';

var AgendaSidebarView = Backbone.View.extend({

    events: {
        'change select[name="view"]': 'viewChanged',
        'click .view-all-btn': 'viewAllTracksClicked'
    },

    initialize: function(options) {
        this.event = Global.get('event');

        if (this.model.get('currentDay')) {
            this.trackCollection = new Backbone.CollectionView({
                collection: this.model.get('currentDay').get('track'),
                selectable: false,
                modelView: AgendaTrackView
            });

            this.listenTo(this.model.get('currentDay'), 'change', this.render);
            this.listenTo(this.model.get('currentDay').get('track'), 'change:disabled', this.renderViewAllBtn);
        }
    },

    viewChanged: function() {
        var value = this.$('select[name="view"]').val();
        this.model.get('agenda').set('viewState', value);
    },

    viewAllTracksClicked: function() {
        this.model.get('currentDay').get('track').invoke('set', {disabled: false});
    },

    remove: function() {
        this.trackCollection && this.trackCollection.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    renderViewAllBtn: function() {
        var disabledTrack = !!this.model.get('currentDay').get('track').findWhere({disabled: true});
        this.$('.view-all-btn').toggleClass('hide', !disabledTrack);
    },

    render: function() {
        this.$el.html(template({
            event: this.event.toJSON(),
            currentDay: this.model.get('currentDay') ? this.model.get('currentDay').toJSON() : undefined,
            daysCount: this.model.get('daysCount')
        }));

        var sidebarTracks = this.$('.sidebar-track-list');

        if (sidebarTracks.length > 0) {
            this.trackCollection.setElement(sidebarTracks).render();
            this.renderViewAllBtn();
        }

        this.$('select[name="view"]').val(this.model.get('agenda').get('viewState'));
        return this;
    }

});

export default AgendaSidebarView;


